(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CC071_collection_tabs"] && !Shopify.designMode) return;
  try {
    
    var circleBorders = document.querySelectorAll(".tab_header .tab-header-item");
    var contentParagraphs = document.querySelectorAll(".tab_content_wrapper .tab_content");

    function showContent(index) {
        for (var i = 0; i < circleBorders.length; i++) {
            circleBorders[i].classList.remove("active");
            contentParagraphs[i].classList.remove("active");
        }

        circleBorders[index].classList.add("active");
        contentParagraphs[index].classList.add("active");
    }

    circleBorders.forEach(function (circle, index) {
        circle.addEventListener("click", function () {
            showContent(index);
        });
    });

    // Show the initial content (one_content)
    showContent(0);
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["CC071_hp_review_slider"] && !Shopify.designMode) return;
  try {
    

function waitForSwiper(trigger) {
      var interval = setInterval(function () {
        if (typeof Swiper != 'undefined') {
          clearInterval(interval);
          trigger();
        }
      })
      setTimeout(function () {
        clearInterval(interval);
      }, 15000)
    }


    function reviewSliderhp() {
      var swiper = new Swiper('.hp_review_slider_071 .review_swiper', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        loop:true,
        breakpoints: {
          1200: {
            slidesPerView: 3,
            spaceBetween: 40
          },
          769: {
            slidesPerView: 2.2,
            spaceBetween: 12
          },
          0: {
            autoHeight: true,
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
      });
    }

       waitForSwiper(function () {
        reviewSliderhp();
      })
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc74-tab-with-icon"] && !Shopify.designMode) return;
  try {
    
function waitForSwiper(trigger) {
    var interval = setInterval(function () {
        if (typeof Swiper !== 'undefined') {
            clearInterval(interval);
            trigger();
        }
    }, 50); // Added interval time
    
    setTimeout(function () {
        clearInterval(interval);
    }, 15000);
}

function GhSlider() {
  
var swiper = new Swiper('.swiper-tabs-cc', {
    slidesPerView: 8,
    spaceBetween: 8,
    loop: true,
    simulateTouch:false,
    a11y:false,
  
     pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
breakpoints: {
    1200:{
        slidesPerView: 8,
        loop: true
    },
  
    0: { 
        slidesPerView: 2.5,
        loop: true
      
    }
  
}
  


  
});

  
}

// Ensure Swiper is loaded before initializing
waitForSwiper(function () {
    GhSlider();
});

function waitForElement(selector, trigger) {
    var interval = setInterval(function () {
        if (document.querySelector(selector)) {
            clearInterval(interval);
            trigger();
        }
    }, 50);

    setTimeout(function () {
        clearInterval(interval);
    }, 15000);
}



  
  // add class to the collection list when clicked [CC060]
  var collectionItems = document.querySelectorAll('.gh-tabs-sec .collection-list-item');

collectionItems.forEach(function(item) {
  var itemUrl = item.getAttribute('href'); // Get the href attribute from the collection item
  var pageUrl = window.location.pathname; // Get the current page's URL path

  // Compare the href with the current page URL and add 'active' class if they match
  if (pageUrl.includes(itemUrl)) {
    item.classList.add('active-tab');
  }

  // Add click event listener to handle clicks and update active class
  item.addEventListener('click', function(event) {

    // Remove the active class from all links
    collectionItems.forEach(function(link) {
      link.classList.remove('active-tab');
    });

    // Add the active class to the clicked link
    event.currentTarget.classList.add('active');
  });
});
  
  
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider-tab"] && !Shopify.designMode) return;
  try {
    
    var circleBorders = document.querySelectorAll(".tab_header .tab-header-item");
    var contentParagraphs = document.querySelectorAll(".tab_content_wrapper .tab_content");

    function showContent(index) {
        for (var i = 0; i < circleBorders.length; i++) {
            circleBorders[i].classList.remove("active");
            contentParagraphs[i].classList.remove("active");
        }

        circleBorders[index].classList.add("active");
        contentParagraphs[index].classList.add("active");
    }

    circleBorders.forEach(function (circle, index) {
        circle.addEventListener("click", function () {
            showContent(index);
        });
    });

    // Show the initial content (one_content)
    showContent(0);
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gh-timer-banner"] && !Shopify.designMode) return;
  try {
    
// Initialize the swiper instance
const swiper = new Swiper('.image_slider .swiper-container', {
  loop: true,
 draggable: true,
  pagination: {
    el: '.image_slider .swiper-pagination',
    clickable: true,
  },
  autoplay: {
    delay: 4000, // Time between slides in milliseconds (4000ms = 4 seconds)
  },
  spaceBetween: 10,
  slidesPerView: 1,
});
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    

  document.querySelectorAll('.cc59-hero.custVideoBrandBanner, section.promo-section').forEach(function (element) {
        element.addEventListener('click', function () {
          if (window.innerWidth <= 768) {
            window.location.href = '/collections/best-sellers';
          }
        });
      });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp_47_popular_product"] && !Shopify.designMode) return;
  try {
    
   var swipertop = document.querySelector(".bm-popular-product-slider");
        var breakpoints = {
            0: { slidesPerView: 1.25 },
            1e3: { slidesPerView: 3 },
            1024: { slidesPerView: 3.5 }
        };
        var creSlider = new Swiper(swipertop, {
            slidesPerView: 4,
            grabCursor: true,
            spaceBetween: 21,
            loop: true,
            breakpoints,
            pagination: {
                el: ".cre-swiper-pagination",
                clickable: true
            },
            navigation: {
                nextEl: ".gh-swiper-button-next",
                prevEl: ".gh-swiper-button-prev"
            }
            // breakpoints,
        });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp_47_product_slider"] && !Shopify.designMode) return;
  try {
    
  
        var swipertop2 = document.querySelector(".bm-arrivals-product-slider");
        var breakpoints = {
            0: { slidesPerView: 1 },
            1e3: { slidesPerView: 1 },
            1024: { slidesPerView: 1 }
        };
        var creSlider2 = new Swiper(swipertop2, {
            slidesPerView: 1,
            grabCursor: true,
            spaceBetween: 21,
            loop: true,
            breakpoints,
            pagination: {
                el: ".cre-swiper-pagination",
                clickable: true
            },
            navigation: {
                nextEl: ".gh-swiper-button-next",
                prevEl: ".gh-swiper-button-prev"
            }
            // breakpoints,
        });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp_47_tabs"] && !Shopify.designMode) return;
  try {
    
          var swipertop1 = document.querySelector(".bm-populargift-product-slider");
        var breakpoints = {
            0: { slidesPerView: 1.25 },
            1e3: { slidesPerView: 3 },
            1024: { slidesPerView: 3.5 }
        };
        var creSlider1 = new Swiper(swipertop1, {
            slidesPerView: 4,
            grabCursor: true,
            spaceBetween: 21,
            loop: true,
            breakpoints,
            pagination: {
                el: ".cre-swiper-pagination",
                clickable: true
            },
            navigation: {
                nextEl: ".gh-swiper-button-next",
                prevEl: ".gh-swiper-button-prev"
            }
            // breakpoints,
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-collection-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.custom_tab_sec');

  sections.forEach(function (section) {
    var circleBorders = section.querySelectorAll('.tab-header-item');
    var contentParagraphs = section.querySelectorAll('.tab_content');

    function showContent(index) {
      circleBorders.forEach(function (circle, i) {
        circle.classList.toggle('active', i === index);
        contentParagraphs[i].classList.toggle('active', i === index);
      });
    }

    circleBorders.forEach(function (circle, index) {
      circle.addEventListener('click', function () {
        showContent(index);
      });
    });

    // Show the initial content (one_content)
    showContent(0);
  });
});
   
  
  } catch(e) { console.error(e); }
})();
})();
